import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {useAppSelector} from "common/hook/UseSelector";
import {useAppDispatch} from "common/hook/UseDispatch";
import {setNotFoundError} from "features/model/slice/error/errorSlice";


function useErrorRedirect() {
    const navigate = useNavigate();
    const errorStatus = useAppSelector(state => state.error.status);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (errorStatus === 404) {
            navigate('/not-found');
            dispatch(setNotFoundError(200));
        }
    }, [errorStatus, navigate, dispatch]);
}

export default useErrorRedirect;
